export const ORDER_TYPE = {
  1: { name: "图文咨询" },
  2: { name: "电话咨询" },
  3: { name: "视频咨询" },
  4: { name: "在线复诊" },
  5: { name: "在线处方" },
  6: { name: "在线签约" },
  7: { name: "检查预约" },
  8: { name: "远程门诊" },
  9: { name: "远程会诊" },
  10: { name: "住院预约" },
  11: { name: "远程影像" },
  12: { name: "远程心电" },
  13: { name: "远程病理" },
  14: { name: "远程转诊" },
  15: { name: "药师审方" },
  16: { name: "在线预约" },
  99: { name: "其他" },
  100: { name: "私人医生" },
  101: { name: "私人医生" },
  102: { name: "私人医生" },
  103: { name: "私人医生" },
};

export const PRESCRIPTION_STATUS = {
  11800: "处方创建(待平台审核)",
  11801: "医生待签字(已开具处方)",
  11802: "审核药师待审核(医生已签字)",
  11803: "审核药师待签字(审核药师已审核)",
  11804: "复核药师待复核(审核药师已签字)",
  11805: "复核药师待签字(复核药师已复核)",
  11806: "待出报告(复核药师已签字)",
  11807: "已出报告",
  11808: "审核药师拒绝(驳回处方)",
  11809: "复核药师拒绝(驳回处方)",
  11810: "处方流转平台通过",
};

export const PRESCRIPTION_STATUS_SIMPLE = {
  11800: "医生待审核",
  11801: "医生待签字",
  11802: "药师待审核",
  11803: "药师待签字",
  11804: "药师待复核",
  11805: "药师待签字",
  11806: "待出报告",
  11807: "已出报告",
  11808: "审核已拒绝",
  11809: "复核已拒绝",
  11810: "通过",
};

export const PRESCRIPTION_BUTTON = {
  11802: "审核",
  11803: "签名",
  11804: "复核",
  11805: "复核签名",
  11806: "生成报告",
  11807: "下载报告",
};

export const ORDER_STATUS = {
  10001: "待支付",
  10002: "待接诊",
  10003: "待确认",
  // 10004: "待评价",
  10005: "已完成",
  // 10006: "退款中",
  // 10007: "已退款",
  10008: "已取消",
  10009: "已关闭",
  10010: "已退诊",
  10011: "进行中",
};

export const PATIENT_GENDER = {
  10901: "男",
  10902: "女",
};
